// extracted by mini-css-extract-plugin
export default {"mainContainer":"CompanyInsurance_mainContainer__X8Xfs","headerContainer":"CompanyInsurance_headerContainer__dIbiA","errorMessage":"CompanyInsurance_errorMessage__Qx-ye"};